module.exports = __webpack_public_path__ + "components/big-check-list/static/check-823615538c5677ef59908bda2a7d3384.svg";